/**
 * Departments Service
 * 
 * Chức năng: Service để gọi API liên quan đến phòng ban
 * Dùng để: 
 * - CRUD operations cho departments
 * - Tập trung logic gọi API departments
 * - Dùng chung cho mobile và desktop app
 */
import { BaseApiService } from './base-api.service';
import { API_ENDPOINTS } from '../constants';
import {
  Department,
  CreateDepartmentDto,
  UpdateDepartmentDto,
  DepartmentListResponse,
  GetDepartmentsParams,
} from '../types';

export abstract class DepartmentsService extends BaseApiService {
  /**
   * Lấy danh sách phòng ban
   */
  async getDepartments(
    params?: GetDepartmentsParams
  ): Promise<DepartmentListResponse> {
    const queryParams = new URLSearchParams();
    
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.isActive !== undefined) {
      queryParams.append('isActive', params.isActive.toString());
    }

    const queryString = queryParams.toString();
    const endpoint = queryString
      ? `${API_ENDPOINTS.DEPARTMENTS.LIST}?${queryString}`
      : API_ENDPOINTS.DEPARTMENTS.LIST;

    return this.get<DepartmentListResponse>(endpoint);
  }

  /**
   * Lấy chi tiết phòng ban theo ID
   */
  async getDepartmentById(id: number): Promise<Department> {
    return this.get<Department>(API_ENDPOINTS.DEPARTMENTS.DETAIL(id.toString()));
  }

  /**
   * Tạo phòng ban mới
   */
  async createDepartment(data: CreateDepartmentDto): Promise<Department> {
    return this.post<Department>(API_ENDPOINTS.DEPARTMENTS.CREATE, data);
  }

  /**
   * Cập nhật phòng ban
   */
  async updateDepartment(
    id: number,
    data: UpdateDepartmentDto
  ): Promise<Department> {
    return this.put<Department>(
      API_ENDPOINTS.DEPARTMENTS.UPDATE(id.toString()),
      data
    );
  }

  /**
   * Xóa phòng ban
   */
  async deleteDepartment(id: number): Promise<{ success: boolean; message: string }> {
    return this.delete<{ success: boolean; message: string }>(
      API_ENDPOINTS.DEPARTMENTS.DELETE(id.toString())
    );
  }
}

